import type { IconProps } from "../types";

/**
 * Hairdryer: ドライヤーアイコン。lucide-react に存在しないため registry svgContent を逐語再現。
 */
export const Hairdryer = ({
	size = 24,
	color = "currentColor",
	strokeWidth = 2,
	className,
	"aria-label": ariaLabel,
}: IconProps) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		stroke={color}
		strokeWidth={strokeWidth}
		strokeLinecap="round"
		strokeLinejoin="round"
		className={className}
		role={ariaLabel ? "img" : undefined}
		aria-label={ariaLabel}
		aria-hidden={ariaLabel ? undefined : true}
	>
		<circle cx="8" cy="8" r="2" />
		<path d="M18 11s-7 3-10 3A6 6 0 0 1 8 2c3 0 10 3 10 3Zm0-6l4-2v10l-4-2" />
		<path d="m7 13.9l.8 5.1c.1.5.6 1 1.2 1h2c.6 0 .9-.4.8-1l-.9-5.5m.74 4.5s3.3-2 7.3-2a2 2 0 0 1 0 4H17a2 2 0 0 0-2 2" />
	</svg>
);
